import { Component, h } from 'preact';
import cx from 'classnames';
import moment from 'moment';

import { Inquiry } from 'types/inquiries';

interface InquiryIdleLabelProps {
  inquiry: Inquiry;
  forTableMode?: boolean;
}

export class InquiryIdleLabel extends Component<InquiryIdleLabelProps> {
  render(props: InquiryIdleLabelProps, state: any) {
    const now = moment();
    const modified = moment(props.inquiry.dateModified);
    const weeksIdle = now.diff(modified, 'weeks');
    const daysIdle = now.diff(modified, 'days');
    let idleDurationText = '';

    if (daysIdle >= 1) {
      if (daysIdle >= 7) {
        idleDurationText = `${weeksIdle} ${weeksIdle == 1 ? 'week' : 'weeks'}`;
      } else {
        idleDurationText = `${daysIdle} ${daysIdle == 1 ? 'day' : 'days'}`;
      }

      return (
        <div className={ cx('hi-inqcard__idle', {
          'hi-inqcard__idle--table-only': props.forTableMode,
          'hi-inqcard__idle--card-only': !props.forTableMode
        }) }>
          <i className="fas fa-exclamation-circle"></i>
          &nbsp;
          { idleDurationText } idle
        </div>
      );
    }
  }
}

